import React from 'react';

/**
 * Global Footer
 */
export function Footer(props) {
  return (
    <footer className={`footer ${(window.avatar) ? 'active' : ''} centered`} id="footer">
    </footer>
  );
}
